import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { ActionButtonLayout } from './styles';

const ActionButton = ({ icon, label, onClick, id, disabled, loading }) => {
  const { t: translate } = useTranslation();

  return (
    <ActionButtonLayout
      type="button"
      id={id}
      onClick={onClick}
      disabled={loading || disabled}
      className={loading ? 'loading' : ''}
    >
      <i className={`bx ${icon}`} />
      <span>{translate(label)}</span>
    </ActionButtonLayout>
  );
};

ActionButton.propTypes = {
  icon: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  id: PropTypes.string,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
};

export default ActionButton;
